module.exports = __webpack_public_path__ + "static/media/Mute.4a6fcace.svg";